"use client";

import { c as _c } from "react/compiler-runtime";
import { parseAsArrayOf, parseAsString, useQueryStates } from "nuqs";
import { useCallback, useMemo } from "react";
import { ProducerFilters } from "./components/producer-filters";
import { ProducersTable } from "./components/producers-table";
import { useProducersData } from "./hooks/use-producers-data";
const FILTER_PARSERS = {
  search: parseAsString.withDefault(""),
  documentType: parseAsString.withDefault(""),
  location: parseAsArrayOf(parseAsString).withDefault([]),
  status: parseAsArrayOf(parseAsString).withDefault([]),
  page: parseAsString.withDefault("1")
};
export function ProducersPageContent() {
  const $ = _c(32);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      history: "replace"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [filters, setFilters] = useQueryStates(FILTER_PARSERS, t0);
  let t1;
  if ($[1] !== setFilters) {
    t1 = updates => {
      const next = {};
      for (const [key, value] of Object.entries(updates)) {
        if (value === "") {
          next[key as keyof typeof filters] = null as never;
        } else {
          next[key as keyof typeof filters] = value as never;
        }
      }
      setFilters(next);
    };
    $[1] = setFilters;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const updateSearchParams = t1;
  const t2 = filters.documentType === "cpf" || filters.documentType === "cnpj" ? filters.documentType : "";
  let t3;
  if ($[3] !== filters.location || $[4] !== filters.page || $[5] !== filters.search || $[6] !== filters.status || $[7] !== t2) {
    t3 = {
      search: filters.search,
      documentType: t2,
      location: filters.location,
      status: filters.status,
      page: filters.page,
      pageSize: 25
    };
    $[3] = filters.location;
    $[4] = filters.page;
    $[5] = filters.search;
    $[6] = filters.status;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    producers,
    paginationInfo,
    uniqueLocations,
    isLoadingProducers,
    isSearching,
    isStale,
    prefetchNextPage
  } = useProducersData(t3);
  const hasActiveFilters = Boolean(filters.search) || Boolean(filters.documentType) || filters.location.length > 0 || filters.status.length > 0;
  let t4;
  if ($[9] !== filters.documentType || $[10] !== filters.location || $[11] !== filters.page || $[12] !== filters.search || $[13] !== filters.status) {
    t4 = {
      search: filters.search,
      documentType: filters.documentType,
      location: filters.location,
      status: filters.status,
      page: filters.page
    };
    $[9] = filters.documentType;
    $[10] = filters.location;
    $[11] = filters.page;
    $[12] = filters.search;
    $[13] = filters.status;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const filterState = t4;
  let t5;
  if ($[15] !== filterState || $[16] !== hasActiveFilters || $[17] !== isSearching || $[18] !== uniqueLocations || $[19] !== updateSearchParams) {
    t5 = <ProducerFilters hasActiveFilters={hasActiveFilters} isSearching={isSearching} searchParams={filterState} uniqueLocations={uniqueLocations} updateSearchParams={updateSearchParams} />;
    $[15] = filterState;
    $[16] = hasActiveFilters;
    $[17] = isSearching;
    $[18] = uniqueLocations;
    $[19] = updateSearchParams;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== hasActiveFilters || $[22] !== isLoadingProducers || $[23] !== isStale || $[24] !== paginationInfo || $[25] !== prefetchNextPage || $[26] !== producers || $[27] !== updateSearchParams) {
    t6 = <ProducersTable data={producers} hasActiveFilters={hasActiveFilters} isLoading={isLoadingProducers} isStale={isStale} paginationInfo={paginationInfo} prefetchNextPage={prefetchNextPage} updateSearchParams={updateSearchParams} />;
    $[21] = hasActiveFilters;
    $[22] = isLoadingProducers;
    $[23] = isStale;
    $[24] = paginationInfo;
    $[25] = prefetchNextPage;
    $[26] = producers;
    $[27] = updateSearchParams;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== t5 || $[30] !== t6) {
    t7 = <div className="space-y-4">{t5}{t6}</div>;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  return t7;
}